import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { addNewTake } from "../../app/slices/TrainingSlice";
import { CreateTransition } from "../../models/interactions/Transition";
import { useTrainingLocalization } from "../trainingLocalization/TrainingLocalizationHooks";

export function useAddTake3D() {
  const dispatch = useDispatch();
  const { getNewKey } = useTrainingLocalization();

  // Each route allocates its own transition: addNewTake no-ops without one, and
  // every transition carries a localization key that must not be shared.
  const addTake = useCallback(() => {
    dispatch(addNewTake({ transition: CreateTransition(getNewKey()) }));
  }, [dispatch, getNewKey]);

  /**
   * Adds a take that inherits nothing from the take before it — no actors,
   * props, situations or attachments. See docs/AddCleanTakeImplementationPlan.md.
   */
  const addCleanTake = useCallback(() => {
    dispatch(
      addNewTake({ transition: CreateTransition(getNewKey()), clean: true })
    );
  }, [dispatch, getNewKey]);

  return { addTake, addCleanTake } as const;
}
